export enum InputType {
  TEXT = 'text',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  DATE = 'date',
  LIST = 'list',
  SECTION = 'section',
  LOCATION = 'location',
  GEOPOLYGON = 'geopolygon',
}

export const InputTypeLabels = {
  text: 'Texto',
  number: 'Número',
  boolean: 'Booleano',
  date: 'Fecha',
  list: 'Lista',
  section: 'Sección',
  location: 'Ubicación',
  geopolygon: 'Polígono',
};
